module.exports = __webpack_public_path__ + "img/login_main.511c5b92.jpg";